import React from "react";
import { MenuContainer, MenuHeader, MenuList, MenuLink } from "./styles";

import { useRouteMatch } from "react-router-dom";

const MenuLinkRoute = ({ to, label }: { to: string; label: string }) => {
    const isActive: boolean = !!useRouteMatch({
        path: to,
        exact: true,
    });

    return (
        <MenuLink active={isActive} to={to}>
            {label}
            <span />
        </MenuLink>
    );
};

const Menu = () => (
    <MenuContainer>
        <MenuHeader>
            <img src="https://i.imgur.com/7jlKUdA.jpg" alt="Umberto Pontes" />
            <strong>Umberto</strong>
        </MenuHeader>

        <MenuList>
            <MenuLinkRoute to="/app" label="Home" />
            <MenuLinkRoute to="/app/categorias" label="Categorias" />
            <MenuLinkRoute to="/app/metas" label="Metas" />
            <MenuLinkRoute to="/app/configuracoes" label="Configurações" />
        </MenuList>
    </MenuContainer>
);

export default Menu;
